import type { InboundReceiveOrderOperator } from "./inboundApi";

/**
 * Receive labor is clocked at the order, but an operator can only be inside one crate.
 * Crate cards show a person only when their open session has claimed that package.
 */
export function inboundReceiveOperatorsOnCrate(
  operators: InboundReceiveOrderOperator[],
  packageId: string,
): InboundReceiveOrderOperator[] {
  const parsed = Number.parseInt(packageId, 10);
  if (!Number.isSafeInteger(parsed) || parsed <= 0) return [];
  return operators.filter((operator) => operator.arrivalPackageId === parsed);
}
